<div fxLayout="row">
  <div fxflex="100">
    <img
      src="/assets/images/test/guardian/guardian_list/banner/guardian_banner.jpg"
      style="object-fit: contain; background-size: cover"
      width="100%"
    />
  </div>
</div>

<mat-grid-list cols="10" rowHeight="3:9">
  <mat-grid-tile [colspan]="6">
    <div class="p-l-10">
      <p>
        Los guardianes de la papa son un grupo de personas dedicadas a la
        agricultura familiar que cultivan de forma tradicional y ecológica una
        gran diversidad de papas nativas, conservando de esta manera nuestro
        legado la cual se transmite de generación en generación. Los guardianes
        de la papa juegan un rol importante en la seguridad alimentaria del
        Perú.
      </p>
      <h4><b>Miskipapa (Comercio Electrónico)</b></h4>
      <p>
        <b>
          Para descubrir lo que nos trae el primer chaqru altoandino de la temporada 2022, por favor complete el
        siguiente formato: <a href="http://bit.ly/Huachhua">http://bit.ly/Huachhua</a>
        </b>
      </p>
      <p style="text-align: center;">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSc9ipBqU3EiBfDlATKmvzqb_UdnM8H9VH40FxUAot10xkXWYg/closedform"
          mat-raised-button color="primary">Comercio Electrónico</a>
      </p>
    </div>
  </mat-grid-tile>
  <mat-grid-tile [colspan]="4">
    <img
      src="/assets/images/test/guardian/guardian_list/banner/guardian_content.jpg"
      style="object-fit: contain; background-size: cover"
      width="100%"
    />
  </mat-grid-tile>
</mat-grid-list>
<br />
<mat-paginator
  [pageIndex]="1"
  [pageSize]="20"
  [length]="100"
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[5, 10, 20, 50, 100]"
  aria-label="Select page"
>
</mat-paginator>
<br />
<mat-grid-list cols="3" gutterSize="25px">
  <mat-grid-tile *ngFor="let tile of tiles; let i = index">
    <div class="w-100 h-100" matRipple (click)="fnItem(tile.id)">
      <mat-card>
        <mat-card-content>
          <img
            mat-card-image
            src="{{ tile.image_src }}"
            style="object-fit: contain"
          />
        </mat-card-content>
      </mat-card>
    </div>
  </mat-grid-tile>
</mat-grid-list>
<br />
<mat-paginator
  [pageIndex]="1"
  [pageSize]="20"
  [length]="100"
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[5, 10, 20, 50, 100]"
  aria-label="Select page"
>
</mat-paginator>
